<script lang="ts">
    import { run } from 'svelte/legacy';

    import { createEventDispatcher } from 'svelte';
    import type { ConditionInputDefinition } from 'header/types';
    import { uniqBy } from 'lodash-es';
    import { CONDITION_MAX_VALUE } from 'portlet/models/settings/settingDefinitions/conditionSettings';

    interface Props {
        field: ConditionInputDefinition;
    }

    let { field }: Props = $props();

    let value: ConditionInputDefinition['value'] | null = $state(field.value);

    run(() => {
        value = field.value;
    });
    let options = $derived(field.options);
    let allowConditionChange = $derived(field.allowConditionChange);
    let conditionMaxValue = $derived(field.conditionMaxValue);
    let conditionVariableName = $derived(field.conditionVariableName);
    let conditionGroup = $derived(value?.group || options[0]?.group || '');
    let currentOptions = $derived(
        conditionGroup ? options.filter(option => option.group === conditionGroup) : options,
    );
    let conditionKey = $derived(value?.key || currentOptions[0]?.key || options[0]?.key);
    let conditionValue = $derived(value?.value || conditionMaxValue || CONDITION_MAX_VALUE);
    let currentOptionsGroups = $derived(uniqBy(options, 'group'));
    let submitable = $derived(
        conditionVariableName &&
            conditionKey &&
            options.find(option => option.key === conditionKey) &&
            conditionValue &&
            conditionValue <= conditionMaxValue &&
            conditionValue > 0,
    );

    const dispatch = createEventDispatcher();

    const onGroupChange = (e: { currentTarget: HTMLSelectElement }) => {
        if (!value) return;
        value.group = e.currentTarget.value;
        value.key = '';
    };

    const onValueChange = (e: { currentTarget: HTMLInputElement }) => {
        if (!value) return;
        value.value = Number.parseInt(e.currentTarget.value, 10);
    };

    const onKeyChange = (e: { currentTarget: HTMLSelectElement }) => {
        if (!value) return;
        value.key = e.currentTarget.value;
    };

    const onSubmit = () => {
        dispatch('change', {
            field: {
                ...field,
                value: {
                    group: conditionGroup,
                    value: conditionValue,
                    key: conditionKey,
                },
            },
        });
    };
</script>

<div>
    <div class="field">
        <select class="select" value={conditionGroup} onchange={onGroupChange}>
            {#each currentOptionsGroups as { group } (group)}
                <option value={group}>{group}</option>
            {/each}
        </select>
        <input
            class="input"
            type="number"
            min="0"
            max={conditionMaxValue}
            value={conditionValue}
            onchange={onValueChange}
        />
    </div>

    {#if allowConditionChange}
        <select class="button" value={conditionKey} onchange={onKeyChange}>
            {#each currentOptions as { key, label }, i (key)}
                <option value={key}>{label}</option>
            {/each}
        </select>
    {/if}
    <button class="button" onclick={onSubmit} disabled={!submitable}>apply</button>
</div>

<style lang="scss" scoped>
    .field {
        overflow-x: auto;
        display: flex;
        align-items: stretch;
        column-gap: 0.5rem;
        font-size: 0.8rem;
    }
    .select,
    .input {
        overflow: hidden;
    }
    .select {
        width: 50%;
    }
    .input {
        width: 50%;
    }
    .button {
        width: 100%;
    }
</style>
